import { render } from "./definitionObj.vue?vue&type=template&id=085a7cdb"
import script from "./definitionObj.vue?vue&type=script&lang=js"
export * from "./definitionObj.vue?vue&type=script&lang=js"

import "./definitionObj.vue?vue&type=style&index=0&id=085a7cdb&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__